import React, { useState, useEffect } from "react";
import { API_URL } from "./config";
import SideBar from "./SideBar";
import Footer from "./Footer";
import { Col, Row, Container, Button, Form } from "react-bootstrap";
import Navbar from "./Navbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import DashboardLayout from "./DashboardLayout/DasboardLayout";
const APILINK = API_URL;

const Broadcast = ({ customersData }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [driversData, setDriversData] = useState([]);

  const getDrivers = async () => {
    try {
      const response = await fetch(`${APILINK}/driver/`);
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);

      // Extract the phone numbers into an array
      const phoneNumbers = data.map((driver) => driver.phone);
      console.log("Phone Numbers:", phoneNumbers);

      // Store the array of phone numbers in state
      setDriversData(phoneNumbers);
    } catch (error) {
      console.log("Failed to fetch drivers:", error);
    }
  };

  const sendSmsBroadcast = async () => {
    if (driversData.length === 0) {
      toast.error("No phone numbers available to send SMS.");
      return;
    }

    const phoneNumbers = driversData.join(", "); // Create a comma-separated string

    try {
      const response = await fetch(
        "https://srv547457.hstgr.cloud:3003/smsendpoint",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            clientid: "1001",
            clientkey: "hdojFa502Uy6nG2",
            message,
            recipients: phoneNumbers.split(", "), // Split back into an array for recipients
            senderid: "REMS",
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error sending OTP:", response.status, errorText);
        toast.error("Failed to send OTP.");
        return false;
      }

      toast.success("Message sent successfully!");
      return true;
    } catch (error) {
      console.error("Network Error:", error);
      toast.error("Could not send OTP. Please check your connection.");
      return false;
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();

    console.log("Message sent:", message);

    await sendSmsBroadcast(); // Call the SMS sending function
    setMessage("");
    await getDrivers(); // Refresh the driver list after sending
  };

  useEffect(() => {
    getDrivers(); // Fetch drivers on component mount
  }, []);

  return (
    <DashboardLayout>
      <div
        style={{
          background: "white",
          minHeight: "100vh",
          padding: "20px",
        }}
      >
        <Container fluid className="d-flex">
          <Row className="w-100">
            <Col md={8} className="mx-auto mt-4 text-center">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "40px",
                  position: "relative",
                }}
              >
                <button
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#002966",
                    fontSize: "24px",
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    transition: "color 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#004999")}
                  onMouseOut={(e) => (e.target.style.color = "#002966")}
                  onClick={() => navigate(-1)}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <h2
                  style={{
                    color: "#002966",
                    margin: "0 auto",
                    fontSize: "2.5rem",
                    fontWeight: "600",
                  }}
                >
                  Broadcast Message To Driver
                </h2>
              </div>

              <Form
                onSubmit={handleSend}
                style={{
                  // maxWidth: "600px",
                  // margin: "60px auto",
                  // padding: "30px",
                  // boxShadow: "0 4px 6px rgba(0, 41, 102, 0.1)",
                  borderRadius: "10px",
                  background: "white",
                }}
              >
                <Form.Group controlId="messageInput">
                  <Form.Control
                    as="textarea" // Changed to textarea
                    placeholder="Type your message here..."
                    value={message}
                    rows={4} // You can adjust the number of rows
                    maxLength={8000}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    style={{
                      padding: "15px",
                      fontSize: "1.1rem",
                      border: "2px solid rgba(0, 41, 102, 0.2)",
                      borderRadius: "8px",
                      marginBottom: "20px",
                      transition: "border-color 0.3s ease",
                      minHeight: "120px", // Added minimum height
                      resize: "vertical", // Allows vertical resizing
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#002966")}
                    onBlur={(e) =>
                      (e.target.style.borderColor = "rgba(0, 41, 102, 0.2)")
                    }
                  />
                </Form.Group>
                <Button
                  type="submit"
                  style={{
                    background: "#002966",
                    border: "none",
                    padding: "12px 30px",
                    fontSize: "1.1rem",
                    borderRadius: "8px",
                    transition: "background-color 0.3s ease",
                    fontWeight: "500",
                    width: "150px",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#004999")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "#002966")
                  }
                >
                  Send
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{
            fontSize: "1rem",
          }}
        />
      </div>
    </DashboardLayout>
  );
};

export default Broadcast;
